// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Tg2rp","link":"styles_link__AZOf2"};